import { AutogenModelLocationCommodity, AutogenRowLocationCommodity } from "./autogen/AutogenModelLocationCommodity";

export class ModelLocationCommodity extends AutogenModelLocationCommodity<RowLocationCommodity> {
    constructor() {
        super(RowLocationCommodity);
    }
}

export class RowLocationCommodity extends AutogenRowLocationCommodity {
}